import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent } from '../../Utilities';
import { Icon } from '../../Icon';
import { getStyles } from './Check.styles';
import { classNamesFunction } from '../../Utilities';
var getClassNames = classNamesFunction();
var CheckBase = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBase, _super);
    function CheckBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckBase.prototype.shouldComponentUpdate = function (newProps) {
        return (this.props.checked !== newProps.checked ||
            this.props.theme !== newProps.theme ||
            this.props.className !== newProps.className);
    };
    CheckBase.prototype.render = function () {
        var _a = this.props, checked = _a.checked, className = _a.className, theme = _a.theme;
        var classNames = getClassNames(getStyles, { theme: theme, className: className, checked: checked });
        return (React.createElement("div", { className: classNames.root },
            React.createElement(Icon, { iconName: "CircleRing", className: classNames.circle }),
            React.createElement(Icon, { iconName: "StatusCircleCheckmark", className: classNames.check })));
    };
    CheckBase.defaultProps = {
        checked: false
    };
    return CheckBase;
}(BaseComponent));
export { CheckBase };
//# sourceMappingURL=Check.base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Check/Check.base.js
// module id = 273
// module chunks = 0